import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { capture, CONSENT_EVENT } from '../analytics';
import { publicPage } from '../attribution';

export default function AnalyticsPageView() {
  const { pathname } = useLocation();
  const lastPage = useRef(null);
  useEffect(() => {
    const page = publicPage(pathname);
    const record = (event) => {
      if (event?.detail === 'denied') lastPage.current = null;
      if (page !== 'other' && lastPage.current !== page && capture('public_page_viewed', { page })) {
        lastPage.current = page;
      }
    };
    record();
    window.addEventListener(CONSENT_EVENT, record);
    return () => window.removeEventListener(CONSENT_EVENT, record);
  }, [pathname]);
  return null;
}
